export const CustomEventType = {
  ApiUnauthenticated: "api-unauthenticated",
} as const;

export type CustomEventType =
  typeof CustomEventType[keyof typeof CustomEventType];

export const dispatchCustomEvent = (eventType: CustomEventType) => {
  document.dispatchEvent(new CustomEvent(eventType));
};

export const addCustomEventListener = (
  eventType: CustomEventType,
  handler: () => void,
) => {
  document.addEventListener(eventType, handler);
};

export const removeCustomEventListener = (
  eventType: CustomEventType,
  handler: () => void,
) => {
  document.removeEventListener(eventType, handler);
};
